export default {
  valueType: 'dateTime',
  FormItemProps: {
    label: '日期时间',
    rules: [],
    style: {}
  },
  ControlProps: {
    disabled: false,
    placeholder: "请选择",
    style: {}
  },
}